import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';

import PropTypes from 'prop-types';

import BasicButton from '../buttons/basicButton';

export default function TranslationWarning({ handleClose, message, open, title }) {
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title1">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description1">{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <BasicButton handleClick={handleClose} type='accept' />
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
TranslationWarning.propTypes = {
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};